import { en_US } from '@/locales'
import { INVALID_TRANSLATION_KEY, TRANSLATION_KEY_NOT_PROVIDED } from '@/data'

export const Translation = (key: TranslationKeys): string => {
    if (!key) return TRANSLATION_KEY_NOT_PROVIDED

    else {
        let translations: TranslationTypes = en_US
        return translations[key] || INVALID_TRANSLATION_KEY
    }
}
